/**
 * Tenant-scoped dashboard features.
 *
 * "Governorate" is an Oman-specific administrative division, so the governorate
 * breakdown only makes sense for the tenants whose task data carries it. Rather
 * than gate on an environment flag, both environments' tenants are listed here:
 * dev's organization 1 / department 12 does not exist in UAT and vice versa, so
 * a single allow-list is unambiguous and there is nothing to keep in sync with
 * REACT_APP_* config.
 *
 * Add a row to onboard another tenant.
 */
const GOVERNORATE_CHART_TENANTS = [
  { organizationId: 23, departmentId: 24 }, // UAT
  { organizationId: 1, departmentId: 12 }, // dev
];

/**
 * These ids arrive from a mix of AppContext state and localStorage, where they
 * may be raw numbers, plain strings, or JSON-quoted strings ("23") depending on
 * which screen wrote them last -- so normalise before comparing.
 */
const toId = (value) => {
  const normalized = String(value ?? "").replace(/"/g, "").trim();
  if (!normalized) return null;
  const numeric = Number(normalized);
  return Number.isFinite(numeric) ? numeric : null;
};

export const canViewGovernorateChart = ({ organizationId, departmentId } = {}) => {
  const org = toId(organizationId);
  const dept = toId(departmentId);
  if (org === null || dept === null) return false;
  return GOVERNORATE_CHART_TENANTS.some(
    (tenant) => tenant.organizationId === org && tenant.departmentId === dept
  );
};

export default canViewGovernorateChart;
